var _path, _path2, _circle, _mask, _path3, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarProfessional(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 131,
    viewBox: "0 0 143 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1874 7.74646C14.4289 8.5807 8.27428 15.2546 8.27428 15.2546V46.5385M55.7528 7.74646C57.9509 9.41493 62.8746 13.2524 64.9848 15.2546V49.0412M64.9848 49.0412C64.9848 49.0412 64.5111 47.7898 61.0973 49.0412M64.9848 49.0412C64.9848 49.0412 67.0091 47.4764 68.56 49.0412M28.057 81.0237C30.8488 81.637 33.9188 81.8545 37.2889 81.5764C39.6383 81.3826 41.8335 81.0152 43.8832 80.5005M28.057 81.0237V92.8386C28.4966 93.6729 29.9034 95.3413 32.0136 95.3413C32.9438 95.3413 34.4208 95.3413 35.9701 95.3413M28.057 81.0237C11.5057 77.3882 4.55461 63.7053 3 53.0683C3 50.2724 5.27163 47.7898 6.27069 47.7898H10.6478C11.3879 47.4764 14.1058 52.5749 14.1838 53.0683C15.4775 61.2431 21.3188 72.5126 37.2889 71.5656C54.1702 70.5645 58.4796 60.1593 58.9192 53.0683C58.9192 53.0683 58.9192 50.2724 61.0973 49.0412M43.8832 80.5005C63.0058 75.6992 68.56 63.045 70.103 53.0683C70.103 53.0683 69.8051 50.2724 68.56 49.0412M43.8832 80.5005C43.8832 84.1961 43.8832 91.8375 43.8832 92.8386C43.8832 93.8397 42.1247 94.9242 41.2455 95.3413C40.0164 95.3413 37.9352 95.3413 35.9701 95.3413M35.9701 95.3413C35.9701 107.021 41.773 129.879 64.9848 127.877C88.1965 125.874 91.3617 103.684 90.0429 92.8386V55.298C90.4825 50.2925 94.7502 39.0303 108.507 39.0303C123.014 39.0303 125.652 49.4583 125.652 55.298V60.3034M61.0973 49.0412C64.128 49.0412 65.5293 49.0412 68.56 49.0412",
    stroke: "#2E7161",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M139.797 75.3199C139.797 81.8097 134.205 87.3361 126.97 87.3361C119.736 87.3361 114.144 81.8097 114.144 75.3199C114.144 68.83 119.736 63.3036 126.97 63.3036C134.205 63.3036 139.797 68.83 139.797 75.3199Z",
    stroke: "#2E7161",
    strokeWidth: 6
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49.5984,
    cy: 5.48217,
    r: 3,
    stroke: "#2E7161",
    strokeWidth: 4.96434
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_1683_9926",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 126.973,
    cy: 75.3199,
    rx: 5.27539,
    ry: 5.00542
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M126.249 75.3199C126.249 74.9403 126.421 74.6516 126.574 74.5067C126.721 74.367 126.875 74.3253 126.973 74.3253V86.3253C132.899 86.3253 138.249 81.6911 138.249 75.3199H126.249ZM126.973 74.3253C127.071 74.3253 127.225 74.367 127.373 74.5067C127.525 74.6516 127.698 74.9403 127.698 75.3199H115.698C115.698 81.6911 121.047 86.3253 126.973 86.3253V74.3253ZM127.698 75.3199C127.698 75.6994 127.525 75.9882 127.373 76.1331C127.225 76.2727 127.071 76.3145 126.973 76.3145V64.3145C121.047 64.3145 115.698 68.9487 115.698 75.3199H127.698ZM126.973 76.3145C126.875 76.3145 126.721 76.2727 126.574 76.1331C126.421 75.9882 126.249 75.6994 126.249 75.3199H138.249C138.249 68.9487 132.899 64.3145 126.973 64.3145V76.3145Z",
    fill: "#2E7161",
    mask: "url(#path-4-inside-1_1683_9926)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.1875,
    cy: 5.48217,
    r: 3,
    stroke: "#2E7161",
    strokeWidth: 4.96434
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarProfessional);
export default __webpack_public_path__ + "static/media/avatar-professional.2114ced89f501722b32843eeb2aae1e7.svg";
export { ForwardRef as ReactComponent };